export const fullAddressString = (addressResponse: any) => {
  let fullAddress;

  if (
    addressResponse?.addAddress1 !== null &&
    addressResponse?.addAddress1 !== ""
  ) {
    fullAddress = addressResponse?.addAddress1;
  }

  if (
    addressResponse?.addAddress2 !== null &&
    addressResponse?.addAddress2 !== ""
  ) {
    fullAddress = `${fullAddress}, ${addressResponse?.addAddress2}`;
  }

  if (
    addressResponse?.addAddress3 !== null &&
    addressResponse?.addAddress3 !== ""
  ) {
    fullAddress = `${fullAddress}, ${addressResponse?.addAddress3}`;
  }

  if (
    addressResponse?.addAddress4 !== null &&
    addressResponse?.addAddress4 !== ""
  ) {
    fullAddress = `${fullAddress}, ${addressResponse?.addAddress4}`;
  }

  if (
    addressResponse?.addAddress5 !== null &&
    addressResponse?.addAddress5 !== ""
  ) {
    fullAddress = `${fullAddress}, ${addressResponse?.addAddress5}`;
  }

  if (
    addressResponse?.addAddress6 !== null &&
    addressResponse?.addAddress6 !== ""
  ) {
    fullAddress = `${fullAddress}, ${addressResponse?.addAddress6}`;
  }

  return fullAddress;
};

export const getDateFromHours = (time: any) => {
  return new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
    ...time.split(":")
  );
};

export const getDatefromSqlDate = (date: any) => {
  return new Date(
    date.substring(0, 4),//day
    (date.substring(5, 7) - 1),//month  javascript counts months from 0 to 11 hence subtarcting 1
    date.substring(8)//year 
  );
};

export const restictDotHyphenAnde = (event: any) => {
  let key = event.which;
  if (key === 109 || key === 69 || key === 110 || key === 189 || key === 190) {
    event.preventDefault()
  }
};

export const convertDatesToStrings = (obj: any): any => {
  if (typeof obj === 'string') {
    // If the string is a valid ISO date, convert it to ISO format
    // If it's an empty string, you may want to handle it differently
    // Here we just return it as-is
    return obj;
  }

  if (obj instanceof Date) {
    return obj.toISOString();
  }

  if (Array.isArray(obj)) {
    return obj.map(convertDatesToStrings);
  }

  if (typeof obj === 'object' && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = convertDatesToStrings(obj[key]);
      return acc;
    }, {} as Record<string, any>);
  }

  return obj;
}